__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/165d8f792508709be3728b73d6d7dfb568b99497/";